import { createEvent, createStore } from 'effector'

export const openDocumentsDrawer = createEvent()
export const closeDocumentsDrawer = createEvent()

export const $isDocumentsDrawerOpen = createStore<boolean>(false)
  .on(openDocumentsDrawer, () => true)
  .on(closeDocumentsDrawer, () => false)
